import { Routes } from '@angular/router';
import { EditProfileComponent } from './components/account/edit-profile/edit-profile.component';
import { CallActionModule } from './components/call-action/call-action.module';
import { CheckInComponent } from './components/check-in/check-in.component';
import { CheckOutComponent } from './components/check-out/check-out.component';
import { DoorLogComponent } from './components/door-log/door-log.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { MessageActionComponent } from './components/message-action/message-action.component';
import { CampaignModule } from './components/offers/campaign.module';
import { PropertyModule } from './components/property/property.module';
import { ReservationsModule } from './components/reservations/reservations.module';
import { DineModule } from './components/dine/dine.module';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { RoomGuestModule } from './components/room-guest/room-guest.module';
import { TicketListComponent } from './components/service-desk/ticket-list/ticket-list.component';
import { UserManagementModule } from './components/user-management/user-management.module';
import { authGuard } from './shared/guards/auth/auth.guard';
import { InquiryTableComponent } from './components/inquiry-table/inquiry-table.component';
import { GoogleSyncTableComponent } from './components/google-sync-table/google-sync-table.component';
import { GuestAlertModule } from './components/guest-alert/guest-alert.module';
import { DataTableComponent } from './shared/components/data-table/data-table.component';
import { AuditLogsComponent } from './components/audit-logs/audit-logs.component';
import { AuditLogDetailsComponent } from './components/audit-logs/audit-log-details/audit-log-details.component';
import { StaffProfileModalComponent } from './components/staff-profile-modal/staff-profile-modal.component';
import {
  AdminRouteEnum,
  BaseRouteEnum,
  PMSRouteEnum,
} from './shared/enums/route.enum';
import { permissionGuard } from './shared/guards/auth/permission.guard';
import {
  AdminPermissionEnum,
  PMS_DINING_ACCESS_PERMISSIONS,
  PMSPermissionEnum,
} from './shared/enums/permission.enum';
import { FolioTableComponent } from './components/folio/folio-table/folio-table.component';

export const routes: Routes = [
  {
    path: BaseRouteEnum.BASE_URL,
    redirectTo: BaseRouteEnum.LOGIN,
    pathMatch: 'full',
  },
  {
    path: BaseRouteEnum.LOGIN,
    loadComponent: () =>
      import('./components/login/login.component').then((c) => LoginComponent),
  },
  {
    path: BaseRouteEnum.RESET_PASSWORD,
    loadComponent: () =>
      import('./components/reset-password/reset-password.component').then(
        (c) => ResetPasswordComponent,
      ),
  },
  {
    path: BaseRouteEnum.ACCESS_DENIED,
    loadComponent: () =>
      import('./components/access-denied/access-denied.component').then(
        (c) => AccessDeniedComponent,
      ),
  },
  {
    path: BaseRouteEnum.CLAIM,
    loadComponent: () =>
      import('./components/offers/claim-approval-form/claim-approval-form.component').then(
        (c) => c.ClaimApprovalFormComponent,
      ),
  },
  {
    path: AdminRouteEnum.ADMIN_BASE_URL,
    loadComponent: () =>
      import('./shared/components/layout/master-layout/master-layout.component').then(
        (c) => c.MasterLayoutComponent,
      ),
    canActivate: [authGuard, permissionGuard],
    data: {
      permission: Object.keys(AdminPermissionEnum).map(
        (k) => AdminPermissionEnum[k as keyof typeof AdminPermissionEnum],
      ),
    },
    loadChildren: () =>
      import('./components/admin/admin.routes').then(
        (m) => m.ADMIN_CHILD_ROUTES,
      ),
  },

  {
    path: PMSRouteEnum.PMS_BASE_URL,
    loadComponent: () =>
      import('./shared/components/layout/master-layout/master-layout.component').then(
        (c) => c.MasterLayoutComponent,
      ),
    canActivate: [authGuard],
    children: [
      {
        path: PMSRouteEnum.PMS_HOME,
        loadComponent: () =>
          import('./components/home/home.component').then((c) => HomeComponent),
        canActivate: [permissionGuard],
        data: {
          permission: Object.keys(PMSPermissionEnum).map(
            (key) => PMSPermissionEnum[key as keyof typeof PMSPermissionEnum],
          ),
        },
      },
      {
        path: PMSRouteEnum.PMS_CHECK_IN,
        loadComponent: () =>
          import('./components/check-in/check-in.component').then(
            (c) => CheckInComponent,
          ),
        // canActivate: [permissionGuard],
        // data: {
        //   permission: [PMSPermissionEnum.PMS_CHECK_IN],
        // },
      },
      {
        path: PMSRouteEnum.PMS_CHECK_IN_REQ,
        loadComponent: () =>
          import('./components/check-in/check-in.component').then(
            (c) => CheckInComponent,
          ),
        // canActivate: [permissionGuard],
        // data: {
        //   permission: [PMSPermissionEnum.PMS_CHECK_IN_REQ],
        // },
      },
      {
        path: PMSRouteEnum.PMS_CHECK_OUT_REQ,
        loadComponent: () =>
          import('./components/check-out/check-out.component').then(
            (c) => CheckOutComponent,
          ),
        // canActivate: [permissionGuard],
        // data: {
        //   permission: [PMSPermissionEnum.PMS_CHECK_OUT_REQ],
        // },
      },
      {
        path: PMSRouteEnum.PMS_EDIT_PROFILE,
        loadComponent: () =>
          import('./components/account/edit-profile/edit-profile.component').then(
            (c) => EditProfileComponent,
          ),
      },
      {
        path: PMSRouteEnum.PMS_CALL_ACTION,
        loadChildren: () =>
          import('./components/call-action/call-action.module').then(
            (c) => CallActionModule,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_CALL],
        },
      },
      {
        path: PMSRouteEnum.PMS_MESSAGE_ACTION,
        loadComponent: () =>
          import('./components/message-action/message-action.component').then(
            (c) => MessageActionComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_MESSAGE],
        },
      },
      {
        path: PMSRouteEnum.PMS_SERVICE_DESK,
        loadComponent: () =>
          import('./components/service-desk/ticket-list/ticket-list.component').then(
            (c) => TicketListComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_SERVICE_TICKET],
        },
      },

      {
        path: PMSRouteEnum.PMS_OFFERS,
        loadChildren: () =>
          import('./components/offers/campaign.module').then(
            (c) => CampaignModule,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [
            PMSPermissionEnum.PMS_OFFER,
            PMSPermissionEnum.PMS_OFFER_CREATE,
          ],
        },
      },
      {
        path: PMSRouteEnum.PMS_ROOM_GUEST,
        loadChildren: () =>
          import('./components/room-guest/room-guest.module').then(
            (c) => RoomGuestModule,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_ROOM, PMSPermissionEnum.PMS_GUEST],
        },
      },
      {
        path: PMSRouteEnum.PMS_USER_MANAGEMENT,
        loadChildren: () =>
          import('./components/user-management/user-management.module').then(
            (c) => UserManagementModule,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [
            PMSPermissionEnum.PMS_USER_READ,
            PMSPermissionEnum.PMS_USER_CREATE,
            PMSPermissionEnum.PMS_USER_DELETE,
            PMSPermissionEnum.PMS_USER_UPDATE,
          ],
        },
      },
      {
        path: PMSRouteEnum.PMS_RESERVATIONS,
        loadChildren: () =>
          import('./components/reservations/reservations.module').then(
            (c) => ReservationsModule,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [
            PMSPermissionEnum.PMS_RESERVATION,
            PMSPermissionEnum.PMS_RESERVATION_CREATE,
            PMSPermissionEnum.PMS_RESERVATION_READ,
          ],
        },
      },
      {
        path: PMSRouteEnum.PMS_GUEST_ALERT,
        loadChildren: () =>
          import('./components/guest-alert/guest-alert.module').then(
            (c) => GuestAlertModule,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [
            PMSPermissionEnum.PMS_GUEST_ALERT,
            PMSPermissionEnum.PMS_COMPOSE_ALERT,
            PMSPermissionEnum.PMS_SMS_LOG,
          ],
        },
      },
      {
        path: PMSRouteEnum.PMS_DOOR_LOG,
        loadComponent: () =>
          import('./components/door-log/door-log.component').then(
            (c) => DoorLogComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [
            PMSPermissionEnum.PMS_DOOR_LOCK_LOG,
            PMSPermissionEnum.PMS_DOOR_LOCK_LOG_READ,
          ],
        },
      },
      {
        path: PMSRouteEnum.PMS_LEAD_INQUIRY,
        loadComponent: () =>
          import('./components/inquiry-table/inquiry-table.component').then(
            (c) => InquiryTableComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_BOOKING_INQUIRY],
        },
      },
      {
        path: PMSRouteEnum.PMS_GSHEET_SYNC,
        loadComponent: () =>
          import('./components/google-sync-table/google-sync-table.component').then(
            (c) => GoogleSyncTableComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_GSHEET_SYNC],
        },
      },
      {
        path: PMSRouteEnum.PMS_FOLIO,
        loadComponent: () =>
          import('./components/folio/folio-table/folio-table.component').then(
            (c) => FolioTableComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_FOLIO_READ],
        },
      },
      {
        path: PMSRouteEnum.PMS_DATA_TABLE,
        loadComponent: () =>
          import('./shared/components/data-table/data-table.component').then(
            (c) => DataTableComponent,
          ),
      },

      {
        path: PMSRouteEnum.PMS_AUDIT_LOG,
        loadComponent: () =>
          import('./components/audit-logs/audit-logs.component').then(
            (c) => AuditLogsComponent,
          ),
      },
      {
        path: PMSRouteEnum.PMS_AUDIT_LOG_DETAILS,
        loadComponent: () =>
          import('./components/audit-logs/audit-log-details/audit-log-details.component').then(
            (c) => AuditLogDetailsComponent,
          ),
      },
      {
        path: PMSRouteEnum.PMS_DINING,
        loadChildren: () =>
          import('./components/dine/dine.module').then((c) => c.DineModule),
        canActivate: [permissionGuard],
        data: {
          permission: [...PMS_DINING_ACCESS_PERMISSIONS],
        },
      },
      {
        path: PMSRouteEnum.PMS_OPERATOR_SYNC,
        loadComponent: () =>
          import('./components/operator-sync/operator-sync-shell.component').then(
            (c) => c.OperatorSyncShellComponent,
          ),
        canActivate: [permissionGuard],
        data: {
          permission: [PMSPermissionEnum.PMS_OPERATOR_SYNC_READ],
        },
        children: [
          {
            path: '',
            redirectTo: PMSRouteEnum.PMS_MARK_VISIBILITY,
            pathMatch: 'full',
          },
          {
            path: PMSRouteEnum.PMS_MARK_VISIBILITY,
            loadComponent: () =>
              import('./components/mark-visibility/mark-visibility.component').then(
                (c) => c.MarkVisibilityComponent,
              ),
            canActivate: [permissionGuard],
            data: {
              permission: [PMSPermissionEnum.PMS_OPERATOR_SYNC_READ],
            },
          },
          {
            path: PMSRouteEnum.PMS_SYNC_HISTORY,
            loadComponent: () =>
              import('./components/sync-history/sync-history.component').then(
                (c) => c.SyncHistoryComponent,
              ),
            canActivate: [permissionGuard],
            data: {
              permission: [PMSPermissionEnum.PMS_OPERATOR_SYNC_READ],
            },
          },
        ],
      },
      {
        path: PMSRouteEnum.PMS_MARK_VISIBILITY,
        loadComponent: () =>
          import('./components/operator-sync/legacy-operator-sync-redirect.component').then(
            (c) => c.LegacyOperatorSyncRedirectComponent,
          ),
        data: { redirectChild: PMSRouteEnum.PMS_MARK_VISIBILITY },
      },
      {
        path: PMSRouteEnum.PMS_SYNC_HISTORY,
        loadComponent: () =>
          import('./components/operator-sync/legacy-operator-sync-redirect.component').then(
            (c) => c.LegacyOperatorSyncRedirectComponent,
          ),
        data: { redirectChild: PMSRouteEnum.PMS_SYNC_HISTORY },
      },
      {
        path: PMSRouteEnum.PMS_STAFF_PROFILE,
        loadComponent: () =>
          import('./components/staff-profile-modal/staff-profile-modal.component').then(
            (c) => StaffProfileModalComponent,
          ),
      },
      {
        path: 'folio-details/:id',
        loadComponent: () =>
          import('./components/folio-details/folio-details.component').then(
            (c) => c.FolioDetailsComponent,
          ),
      },

      // {
      //   path: 'room-details',
      //   loadComponent: () =>
      //     import('./components/property/room-details/room-details.component').then(
      //       (c) => RoomDetailsComponent
      //     ),
      // },
    ],
  },
  {
    path: BaseRouteEnum.PROPERTY,
    loadChildren: () =>
      import('./components/property/property.module').then(
        (c) => PropertyModule,
      ),
  },
];
